import { Launch } from "@mui/icons-material";
import CloseIconSVG from "assets/svg/campaign/close-icon";
import { Link } from "react-router-dom";
import {
  backdropTransition,
  leadDetailTransition,
} from "../../preview/transitions";
import Backdrop from "./backdrop";
import LeadDetailContent from "./content";
import "./styles.css";

export default function LeadDetail({
  overlay = false,
  toggleOverlay = () => {},
  data = {},
}) {
  const condition = data?.campaign_popup?.popup_condition ?? {};
  return (
    <>
      <div className="preview-lead-details h-full">
        <Backdrop
          initial="initial"
          animate={overlay ? "show" : "hide"}
          variants={backdropTransition}
          onClick={() => toggleOverlay(!overlay)}
          zIndex="z-9999"
        ></Backdrop>
        <LeadDetailContent
          initial="initial"
          animate={overlay ? "show" : "hide"}
          variants={leadDetailTransition.parent}
        >
          {/*start content*/}
          <div className="lead-details-content-item overflow-y-auto custom-scroll">
            {/* title */}
            <div className="w-full flex justify-between">
              <div className="flex items-center">
                <h3 className="text-xl font-medium">Details</h3>
              </div>
              <button onClick={() => toggleOverlay(!overlay)}>
                <CloseIconSVG />
              </button>
            </div>
            {/* content */}
            <div className="w-full mt-7 grid grid-cols-1 gap-y-4">
              <div className="w-full">
                <p className="font-bold text-base text-black text-opacity-50">
                  Name
                </p>
                <p>{data?.firstname}</p>
              </div>
              <div>
                <p className="font-bold text-base text-black text-opacity-50">
                  Email Address
                </p>
                <p>
                  {data?.email ? (
                    <a href={`mailto:${data.email}`} className="text-secondary">
                      {data.email}
                    </a>
                  ) : (
                    "---"
                  )}
                </p>
              </div>
              {data?.phone && (
                <div>
                  <p className="font-bold text-base text-black text-opacity-50">
                    Phone Number
                  </p>
                  <p>{data?.phone}</p>
                </div>
              )}
              {data?.dropdown && (
                <div>
                  <p className="font-bold text-base text-black text-opacity-50">
                    Enquiry Type
                  </p>
                  <p>{data.dropdown}</p>
                </div>
              )}
              {data?.message && (
                <div>
                  <p className="font-bold text-base text-black text-opacity-50">
                    Message
                  </p>
                  <p className="break-all">{data?.message}</p>
                </div>
              )}
              {data?.coupon && (
                <div>
                  <p className="font-bold text-base text-black text-opacity-50">
                    Coupon Code
                  </p>
                  <p>{data.coupon}</p>
                </div>
              )}
              <div className="pt-4 border-t border-thBorder">
                <p className="font-bold text-base text-black text-opacity-50">
                  Campaign
                </p>
                <p>
                  {data?.campaign_id ? (
                    <Link
                      to={`/campaign-details/${data?.campaign_id}/popouts`}
                      className="text-secondary"
                    >
                      {data?.campaign?.title}
                    </Link>
                  ) : (
                    "Missing/deleted campaign"
                  )}
                  {condition?.title && ` / ${condition?.title}`}
                </p>
              </div>
              <div>
                <p className="font-bold text-base text-black text-opacity-50">
                  Popout
                </p>
                <p>
                  {data?.popup_id ? (
                    <Link
                      to={`/campaigns/popup/${data?.popup_id}`}
                      className="text-secondary"
                    >
                      {data?.popup?.title}
                    </Link>
                  ) : (
                    "Missing/deleted popout"
                  )}
                </p>
              </div>
              <div className="pt-4 border-t border-thBorder">
                <p className="font-bold text-base text-black text-opacity-50">
                  Page URL
                </p>
                <p>
                  {data?.pageUrl ? (
                    <a
                      href={data.pageUrl}
                      className="text-secondary"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {data.pageUrl}{" "}
                      <Launch fontSize="inherit" className="text-xs" />
                    </a>
                  ) : (
                    "URL missing"
                  )}
                </p>
              </div>
              <div>
                <p className="font-bold text-base text-black text-opacity-50">
                  Entry Date
                </p>
                <p>{new Date(data?.created_at).toLocaleString()}</p>
              </div>
            </div>
            {/* end: content */}
          </div>
        </LeadDetailContent>
      </div>
    </>
  );
}
